export const initialInputStyles = theme => ({
  root: {
    borderRadius: 0,
    '&:hover $notchedOutline': {
      borderColor: theme.palette.grey[600]
    },
    '&$focused $notchedOutline': {
      borderColor: theme.palette.secondary.main,
      borderWidth: 1
    },
    '& $clearIndicatorDirty': {
      visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */
    '@media (pointer: fine)': {
      '& $clearIndicatorDirty': {
        visibility: 'visible'
      }
    },
    '& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
      opacity: 1
    }
  },
  focused: {},
  input: {
    display: 'block',
    ...theme.typography.body2
  },
  formHelperMessage: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: theme.spacing(2.25),
    marginLeft: 0,
    '& svg': {
      fontSize: '1.5rem',
      marginRight: 10
    },
    ...theme.typography.body2
  }
});

const styles = theme => ({
  ...initialInputStyles(theme),
  textInputRoot: {},
  clearIndicator: {
    marginRight: -2,
    padding: 4,
    visibility: 'hidden',
    color: theme.palette.grey[600],
    '& svg': {
      fontSize: '1rem'
    }
  },
  clearIndicatorDirty: {},
  notchedOutline: {
    borderColor: theme.palette.grey[500]
  },
  adornedEnd: {}
});

export const textInputTitleStyles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(6.5)
  },
  savedText: {
    ...theme.typography.body2,
    lineHeight: '.875rem',
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    color: theme.palette.grey[600],
    '& svg': {
      fontSize: '1rem',
      color: theme.palette.primary.dark,
      marginLeft: 10
    },
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline'
    },
    '& div': {
      maxWidth: 'calc(100% - 26px)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  saveCheck: {
    padding: 4,
    visibility: 'hidden',
    color: theme.palette.primary.main,
    '& svg': {
      fontSize: '1rem'
    },
    '&$saveCheckDirty': {
      visibility: 'visible'
    }
  },
  saveCheckDirty: {}
});

export const numberInputStyles = theme => ({
  ...initialInputStyles(theme),
  root: {
    '& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
      opacity: 1
    }
  },
  input: {
    ...initialInputStyles(theme).input,
    padding: '18px 0px 18px 16px'
  }
});

export default styles;
